import {createStyles} from '@mantine/core';

export const useStyles = createStyles(theme => ({
	wrapper: {

	},
	cleanBtn: {
		background: 'none',
		border: 'none',
		padding: 0,
		font: 'inherit',
		color: 'inherit',
		cursor: 'pointer',
	},
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		cursor: 'pointer',
		padding: '4px 12px',
		borderRadius: '8px',
		background: 'transparent',
		border: 0,
		font: 'inherit',
		color: 'inherit',
		whiteSpace: 'nowrap',
	},
	buttonContainerActive: {
		color: theme.colors.light.primary.default,
	},
	dropdownBody: {
		minWidth: 220,
		borderRadius: 10,
		padding: 6,
		boxShadow: theme.shadows.md,
	},
	dropdownItem: {
		minHeight: 40,
		borderRadius: 7,
		paddingLeft: 12,
		paddingRight: 12,
		'&:hover': {
			backgroundColor: theme.colors.light.neutral.secondary,
		},
	},
	dropdownItemActive: {
		color: theme.colors.light.primary.default,
		backgroundColor: theme.colors.light.primary.background,
	},
}));
